import React from "react";

export const LogoMark = ({ className = "h-8 w-8" }) => (
  <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} aria-hidden="true">
    <rect width="40" height="40" rx="8" fill="#0F172A" />
    <path
      d="M14 12V28M14 12H22C24.7614 12 27 14.2386 27 17C27 19.7614 24.7614 22 22 22H14M22 22L27 28"
      stroke="white"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="14" cy="12" r="2" fill="#10B981" />
  </svg>
);

export default function Logo({ markClass = "h-8 w-8", wordClass = "text-sm", wordColor = "text-slate-900" }) {
  return (
    <span className="inline-flex items-center gap-2.5">
      <LogoMark className={markClass} />
      <span className={`font-display font-semibold uppercase tracking-[0.18em] ${wordClass} ${wordColor}`}>
        İRA Finans
      </span>
    </span>
  );
}
